<template>
  <div
    :style="boxStyle"
    class="notice-container"
    :class="{ heighten: curSwiperType == 'video' }"
  >
    <div class="zhanwei" v-if="localNoticeArr.length">
      {{ localNoticeArr1[0].userName }} &nbsp;&nbsp;{{
        localNoticeArr1[0].desc
      }}
    </div>
    <ul class="notice-wrap" ref="noticeWrap" v-if="localNoticeArr.length">
      <li
        class="notice-item"
        v-for="(item, index) in localNoticeArr"
        :key="item.userId"
        :class="[!index && play ? 'toUp' : '']"
      >
        {{ item.userName }} &nbsp;&nbsp;{{ item.desc }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NoticeBar",
  props: {
    noticeArr: {
      type: Array,
      default: () => [],
    },
    interval: {
      type: Number,
      default: 3000,
    },
    curSwiperType: {
      type: String,
      default: "image",
    },
  },
  data() {
    return {
      play: false,
      localNoticeArr: [...this.noticeArr], // 复制一份数组
      localNoticeArr1: JSON.parse(JSON.stringify(this.noticeArr)), // 复制一份数组
      itemWidths: [], // 存储每个 notice-item 的宽度及其对应的 userId
    };
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.timer = setInterval(this.startPlay, this.interval); // 启动定时器
  },
  methods: {
    startPlay() {
      this.play = true;

      // 切换后重新计算每个 item 的宽度
      setTimeout(() => {
        this.localNoticeArr1.push(this.localNoticeArr1[0]);
        this.localNoticeArr1.shift();
        this.$nextTick(() => {
          this.localNoticeArr.push(this.localNoticeArr[0]);
          this.localNoticeArr.shift();
          this.play = false;
        });
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.notice-container {
  position: absolute;
  max-width: 100%;
  bottom: 100px;
  z-index: 99;
  left: 32px;
  display: flex;
  height: 42px;
  flex-direction: column;
  &.heighten {
    bottom: calc(86px + 60px);
  }
  .zhanwei {
    opacity: 0;
    font-size: 20px;
    padding: 0 12px;
    height: 42px;
    line-height: 42px;
    text-align: left;
    overflow: hidden;
  }
  .notice-wrap {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 42px;
    border-radius: 100px;
    margin: 0 auto;
    overflow: hidden;
    text-align: left;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 20px;
    padding: 0 12px;

    .notice-item {
      width: 100%;
      height: 42px;
      line-height: 42px;
      box-sizing: border-box;
    }

    .toUp {
      margin-top: -42px;
      transition: all 0.5s;
    }
  }
}
</style>
